import { setLocalStorage } from '~/ZenOne-StoryBook/helpers/localStorage'
import { CATALOG_ALIAS } from '~/components/Catalog/helper'
import { DEFAULT_FILTERS } from '~/components/Catalog/CatalogFilters/helper'

export const onSetInitDefaultFiltersCatalogLocalStorage = () => {
  const DEFAULT_SORT = {
    name: 'Popularity',
    value: '-popularity',
  }

  const data = {
    name: CATALOG_ALIAS,
    data: {
      filters: { ...DEFAULT_FILTERS },
      sort: { ...DEFAULT_SORT },
    },
  }
  setLocalStorage(data)
}
